import React from "react";
import { Chip } from "@mui/material";

const statusConfig = {
  upcoming: { label: "Upcoming", color: "default" },
  open: { label: "Open", color: "success" },
  locked: { label: "Locked", color: "warning" },
  live: { label: "Live", color: "info" },
  finalised: { label: "Finalised", color: "secondary" },
};

const GameweekStatusBadge = ({ status }) => {
  const config = statusConfig[status] || statusConfig.upcoming;

  return (
    <Chip
      label={config.label}
      color={config.color}
      size="small"
      variant="outlined"
    />
  );
};

export default GameweekStatusBadge;
